import React from 'react';
import { Modal, ModalBody, Container, Row, Col, Button } from 'reactstrap';

export const OnboardSuccessModal = ({ isOpen, onClose, onContinue }) => (
  <Modal isOpen={isOpen} centered>
    <ModalBody>
      <h6>Congratulations! You've completed the Getting Started Welcome Guide.</h6>
      <Container fluid>
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <Button onClick={onClose}>Stay Here</Button>
          </Col>
          <Col xs="auto">
            <Button onClick={onContinue} color="primary">
              Go to the most recent Weekly Guide
            </Button>
          </Col>
        </Row>
      </Container>
    </ModalBody>
  </Modal>
);

export const OnboardSkipModal = ({ isOpen, onSkip, onDontSkip }) => (
  <Modal isOpen={isOpen} centered>
    <ModalBody>
      <h6>Would you like to see this Getting Started Action Guide again?</h6>
      <Container fluid>
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <Button onClick={onSkip}>Yes</Button>
          </Col>
          <Col xs="auto">
            <Button onClick={onDontSkip} color="light">
              No
            </Button>
          </Col>
        </Row>
      </Container>
    </ModalBody>
  </Modal>
);
